import { FeatureToggle } from "raci-react-library-npe";

export const applyFeatureToggles = (headers: any, toggles: FeatureToggle[]): any => {
  toggles.forEach((toggle: any) => {
    headers[toggle.headerName] = true;
  });

  return headers;
};
